import { DataSource, Layout, Table, } from "@mcleod/components";

export abstract class AutogenLayoutOfferOrderTable extends Layout {
    sourceMovement: DataSource;
    sourceOfferOrder: DataSource;
    tableOffers: Table;
}
